<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>礼品管理</span>
          <el-button type="primary" @click="openDialog()" style="float: right" size="small">添加礼品</el-button>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item label="礼品名称">
          <el-input v-model="searchForm.name" placeholder="请输入礼品名称" style="width: 180px" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="礼品类型">
          <el-select v-model="searchForm.giftTypeId" placeholder="全部" clearable style="width: 160px" @change="handleSearch">
            <el-option v-for="gt in giftTypeList" :key="gt.id" :label="gt.name" :value="gt.id">
              <span style="float: left">{{ gt.name }}</span>
              <span
                v-if="gt.color"
                :style="'float: right; width: 12px; height: 12px; margin-top: 11px; border-radius: 2px; background: ' + gt.color"
              ></span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="giftList" style="width: 100%" stripe>
        <el-table-column prop="id" label="ID" width="60"></el-table-column>
        <el-table-column prop="name" label="礼品名称" min-width="140"></el-table-column>
        <el-table-column prop="code" label="礼品编码" width="130"></el-table-column>
        <el-table-column label="礼品类型" min-width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.giftTypeList && scope.row.giftTypeList.length" style="display:flex; flex-wrap:wrap; gap:4px">
              <el-tag
                v-for="g in scope.row.giftTypeList"
                :key="g.giftTypeId"
                :color="g.giftTypeColor || '#E6A23C'"
                :style="(g.giftTypeColor ? 'color:#fff;border-color:' + g.giftTypeColor : 'color:#fff;border-color:#E6A23C')"
                size="mini"
              >
                {{ g.giftTypeName }}
              </el-tag>
            </div>
            <span v-else style="color:#909399">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="80" align="center" sortable>
          <template slot-scope="scope">
            <el-tag size="mini" type="info">{{ scope.row.sortOrder != null ? scope.row.sortOrder : 0 }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格" width="90">
          <template slot-scope="scope">¥{{ scope.row.price || 0 }}</template>
        </el-table-column>
        <el-table-column prop="stock" label="库存" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="lowStock(scope.row) ? 'danger' : 'success'" size="mini">{{ scope.row.stock }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openDialog(scope.row)">修改</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-4">
        <el-pagination
          @size-change="s => { pageSize = s; getGiftList() }"
          @current-change="p => { currentPage = p; getGiftList() }"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <el-dialog :title="form.id ? '编辑礼品' : '添加礼品'" :visible.sync="dialogVisible" width="550px" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="礼品名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入礼品名称"></el-input>
        </el-form-item>
        <el-form-item label="礼品编码">
          <el-input v-model="form.code" placeholder="留空自动生成 G开头"></el-input>
        </el-form-item>
        <el-form-item label="礼品类型">
          <el-select
            v-model="form.giftTypeIds"
            multiple
            clearable
            placeholder="请选择礼品类型（可多选）"
            style="width: 100%"
          >
            <el-option
              v-for="t in giftTypeList"
              :key="t.id"
              :label="t.name"
              :value="t.id"
            >
              <span style="float: left">{{ t.name }}</span>
              <span
                v-if="t.color"
                :style="'float: right; width: 14px; height: 14px; margin-top: 10px; border-radius: 2px; background: ' + t.color"
              ></span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="价格" prop="price">
              <el-input-number v-model="form.price" :min="0" :precision="2" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="库存" prop="stock">
              <el-input-number v-model="form.stock" :min="0" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="排序值">
              <el-input-number v-model="form.sortOrder" :min="0" :step="1" controls-position="right" placeholder="数字越小越靠前" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="描述">
          <el-input v-model="form.description" type="textarea" placeholder="请输入描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { giftApi, giftTypeApi, applicableTypeApi } from '../api/api'

export default {
  data() {
    return {
      giftList: [],
      giftTypeList: [],
      applicableTypeList: [],
      searchForm: { name: '', giftTypeId: null },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      form: {},
      rules: {
        name: [{ required: true, message: '请输入礼品名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        stock: [{ required: true, message: '请输入库存', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.getGiftList()
    this.loadGiftTypes()
    this.loadApplicableTypes()
  },
  methods: {
    loadGiftTypes() {
      giftTypeApi.getGiftTypeList(1).then(res => { this.giftTypeList = res.data || [] }).catch(() => {})
    },
    loadApplicableTypes() {
      applicableTypeApi.getApplicableTypeList(1).then(res => { this.applicableTypeList = res.data || [] }).catch(() => {})
    },
    getGiftList() {
      giftApi.getGiftPage(this.currentPage, this.pageSize, this.searchForm.name, this.searchForm.giftTypeId).then(res => {
        this.giftList = res.data.records || []
        this.total = res.data.total || this.giftList.length
      })
    },
    lowStock(row) {
      return (row.stock || 0) <= 0
    },
    handleSearch() { this.currentPage = 1; this.getGiftList() },
    resetSearch() {
      this.searchForm = { name: '', giftTypeId: null }
      this.handleSearch()
    },
    openDialog(row) {
      this.loadGiftTypes()
      this.loadApplicableTypes()
      let giftTypeIds = []
      if (row) {
        if (row.giftTypeIds && row.giftTypeIds.length) {
          giftTypeIds = [...row.giftTypeIds]
        } else if (row.giftTypeList && row.giftTypeList.length) {
          giftTypeIds = row.giftTypeList.map(x => x.giftTypeId)
        }
      }
      this.form = row
        ? { ...row, stockLimit: 0, sortOrder: row.sortOrder != null ? row.sortOrder : 0, giftTypeIds }
        : { stock: 0, price: 0, stockLimit: 0, sortOrder: 0, applicableTypeId: null, applicableCount: null, giftTypeIds: [] }
      this.dialogVisible = true
    },
    handleDelete(id) {
      this.$confirm('确定要删除该礼品吗？', '提示', { type: 'warning' }).then(() => {
        giftApi.deleteGift(id).then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success('删除成功')
            this.getGiftList()
          }
        })
      }).catch(() => {})
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.form.giftTypeIds = this.form.giftTypeIds || []
        const action = this.form.id ? giftApi.updateGift(this.form) : giftApi.addGift(this.form)
        action.then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success(this.form.id ? '更新成功' : '添加成功')
            this.dialogVisible = false
            this.getGiftList()
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; }
</style>
